import { render, staticRenderFns } from "./DebugPrices.vue?vue&type=template&id=56990dd2&scoped=true&"
import script from "./DebugPrices.vue?vue&type=script&lang=js&"
export * from "./DebugPrices.vue?vue&type=script&lang=js&"
import style0 from "./DebugPrices.vue?vue&type=style&index=0&id=56990dd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56990dd2",
  null
  
)

export default component.exports